import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import LoadingSpinner from "../LoadingSpinner";

export default function CompareAthleteResultsList({
  loading,
  shouldSearchAfterLoad,
  adjustedHeight,
  athletes,
  hasAppliedSimilarFilters,
  observerTarget,
  isLoadingMore,
  hasMore,
  onSelectAthlete,
}) {
  if (loading && shouldSearchAfterLoad) {
    return (
      <p className="w-full p-2 mt-10 flex flex-col items-center italic text-xl text-gray-500">
        Loading data… your search will be performed shortly.
      </p>
    );
  }

  if (loading) {
    return (
      <div className="mt-5">
        <LoadingSpinner />
      </div>
    );
  }

  return (
    <ul
      className="list-none p-0 mt-4 overflow-y-auto px-3 -mr-4"
      style={{ height: `${adjustedHeight}px` }}
    >
      {athletes.length > 0 ? (
        <>
          {athletes.map((athlete) => (
            <li
              key={athlete.userAthleteId || athlete.userId}
              className="cursor-pointer p-2 hover:bg-gray-200 border-slate-500 border mb-4 rounded-md px-2 shrink-0"
              onClick={() => onSelectAthlete(athlete)}
            >
              <div className="flex justify-between items-center">
                <div className="flex flex-row flex-1">
                  <div className="my-auto rounded-md">
                    <img
                      alt={`${athlete.name} ${athlete.lastname}`}
                      src={athlete.profilePicture || "/default-profile-img.png"}
                      className="grow-0 shrink-0 rounded-md h-[40px] w-[40px]"
                      height={40}
                      width={40}
                    />
                  </div>
                  <div className="ml-4">
                    <p className="text-base lg:text-lg uppercase">
                      {athlete.name} {athlete.lastname}
                    </p>
                    <p className="text-sm text-gray-700">{athlete.position}</p>
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <FontAwesomeIcon icon={faChevronRight} />
                </div>
              </div>
            </li>
          ))}

          {observerTarget ? (
            <div ref={observerTarget} style={{ height: "1px" }} />
          ) : null}

          {isLoadingMore ? (
            <li className="flex justify-center py-3">
              <div className="text-gray-500 text-sm">
                Loading more athletes...
              </div>
            </li>
          ) : null}

          {!hasMore && athletes.length > 0 ? (
            <li className="flex justify-center py-3">
              <div className="text-gray-400 text-xs">
                All matches loaded ({athletes.length})
              </div>
            </li>
          ) : null}
        </>
      ) : hasAppliedSimilarFilters ? (
        <div className="w-full p-2 mt-5 flex flex-col items-center">
          <img
            alt="No results found"
            src="/nodata.gif"
            className="object-cover h-20 w-20 rounded-full border-gray-300 border"
          />
          <span className="mt-4 text-center text-base font-medium text-gray-600">
            No Results Found
          </span>
          <p className="text-gray-500 text-sm">
            Try adjusting the filters to find what you're looking for.
          </p>
        </div>
      ) : null}
    </ul>
  );
}
